import React, { useContext, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch';
import styled from 'styled-components';
import { minBreakpointQuery, standardColours } from '../styles';
import SearchBox from './SearchBox';
import SearchResult from './SearchResult';
import { StoreContext } from '../context/StoreContext';

const StyledSearch = styled.div`
  position: relative;
  background-color: ${standardColours.white};

  ${minBreakpointQuery.large`
    padding: 10px;
  `}
`;

const Search = ({ ...props }) => {
  const { isSearchOpen, setSearchOpen } = useContext(StoreContext);
  const [query, setQuery] = useState();

  const algoliaClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  );

  const searchClient = {
    search(requests) {
      if (requests[0].params.query === '') {
        return new Promise(resolve =>
          resolve({
            results: [
              {
                hits: [],
              },
              {
                hits: [],
              },
              {
                hits: [],
              },
              {
                hits: [],
              },
              {
                hits: [],
              },
              {
                hits: [],
              },
            ],
          }),
        );
      }

      return algoliaClient.search(requests);
    },
  };

  const indices = [{ name: `Products`, title: `Products` }];

  return (
    <StyledSearch {...props}>
      <InstantSearch searchClient={searchClient} indexName={indices[0].name}>
        <SearchBox setQuery={setQuery} setSearchOpen={setSearchOpen} />
        <SearchResult
          indices={indices}
          query={query}
          show={isSearchOpen}
          setSearchOpen={setSearchOpen}
        />
        <Configure hitsPerPage={6} />
      </InstantSearch>
    </StyledSearch>
  );
};

export default Search;
